import { DateTime } from 'luxon'

/** Rótulo curto no card (ref. mockup: "Abre às 09:00"). */
export const formatOpensAtLabel = (isoUntil: string): string => {
  const until = DateTime.fromISO(isoUntil)

  if (!until.isValid) {
    return 'Abre em breve'
  }

  return `Abre às ${until.toFormat('HH:mm')}`
}
